export default __webpack_public_path__ + "static/cnhindustrial-460b2e80d4a6b8db3822a2ebf6da4ab7.jpeg";